import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import {
	Button,
	ButtonSize,
	ColourStateOutline,
	ContentBlock,
	FlexGap,
	FlexJustify,
	Padding,
	Tooltip,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import React from 'react';
import { useNavigate } from 'react-router';
import { IncomingRecipientNameType } from '@ukpostbox/client-data/lib/Types/MailItemTypes';

type MailItemAssignedMetaType = {
	name?: string | null;
	incomingRecipientName?: IncomingRecipientNameType | null;
};

function MailItemAssignedMeta(props: MailItemAssignedMetaType) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	return (
		<ContentBlock
			title={t('mailItem.labels.assigned')}
			content={props.incomingRecipientName?.name || props.name || 'No Name'}
			iconContent={{ icon: faUser, iconSpacing: FlexGap.Small, iconSize: 'lg' }}
			padding={Padding.ExtraSmall}
			stacked={isTiny || isSmall || isMedium}
			justify={FlexJustify.Start}
			addon={
				props.incomingRecipientName ? (
					<Tooltip content={t('mailItem.actions.nameFilter')}>
						<Button
							title={t('mailItem.labels.assigned')}
							icon={faSearch}
							iconOnly
							size={ButtonSize.Small}
							colour={ColourStateOutline.Secondary}
							onClick={() =>
								props?.incomingRecipientName
									? navigate('/mail/all', {
											state: {
												folderId: 8,
												incomingRecipientNameIds: props?.incomingRecipientName.id,
												incomingRecipientNameIdsFriendly: `Name: ${props?.incomingRecipientName.name}`,
											},
										})
									: null
							}
						/>
					</Tooltip>
				) : undefined
			}
		/>
	);
}

export { MailItemAssignedMeta };
